'use client';
import { SelectWithAction, SelectWithActionProps } from '@components/ui';
import {
  Control,
  Controller,
  UseFormRegister,
  FieldErrors,
} from 'react-hook-form';
import { Field, FieldProps } from './field';
import { Field as ChakraField } from '@chakra-ui/react';

interface FormSelectProps
  extends
    Omit<SelectWithActionProps, 'onSelect'>,
    Omit<FieldProps, keyof SelectWithActionProps> {
  label: string;
  id: string;
  register: UseFormRegister<any>;
  control: Control<any>;
  errors: FieldErrors;
  showLabelAtTop?: boolean;
}

const FormSelect = ({
  label,
  id,
  register,
  control,
  errors,
  disabled,
  isShowLabel = true,
  disableLabel,
  helperText,
  items,
  labelProps,
  showLabelAtTop = false,
  required = false,
  optionalText,
  ...rest
}: FormSelectProps) => {
  return (
    <Field
      label={!showLabelAtTop && label}
      invalid={!!errors?.[id]}
      id={id}
      errorText={errors?.[id]?.message as string}
      helperText={helperText}
      disabled={disabled}
      isShowLabel={isShowLabel}
      disableLabel={disableLabel}
      labelProps={labelProps}
      required={required}
      optionalText={optionalText}
    >
      {showLabelAtTop && label && (
        <ChakraField.Label mb={2} color="tertiary.fg">
          {label} <ChakraField.RequiredIndicator fallback={optionalText} />
        </ChakraField.Label>
      )}
      <Controller
        control={control}
        name={id}
        render={({ field }) => {
          return (
            <SelectWithAction
              placeholder={`Select ${label || id}`}
              items={items ?? []}
              onSelect={(value: any) => field.onChange(value)}
              onBlur={() => field.onBlur()}
              disabled={disabled}
              defaultValue={field.value}
              {...rest}
            />
          );
        }}
      />
    </Field>
  );
};

export default FormSelect;
